import React from 'react';
import { ChipGroupContext } from './chip-group-transition-context';
/**
 * Provides internal transition params deep in react tree.
 * @internal
 */
export const ChipsGroupTransitionProvider = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(ChipGroupContext.Provider, {
  value: props
}, children);